import React, { Component } from "react";

class ResetPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return (
            <div>
                Reset Password
            </div>
        );
    }
}

export default ResetPassword;
